// tailwind.config.js
const plugin = require("tailwindcss/plugin");

const rem = 16;
const pageWidth = 816;
const pageHeight = 1056;
const imageWidth = 174;
const factor = 816 / 615;
const marginTop = 82;
const marginBottom = 50;
const pageMargin = 43 * factor + 1.5 * rem;
const pageMarginMax = 5 * factor + 1.5 * rem;

module.exports = {
  // v3+  ⇣   (add any other glob patterns you use: .jsx, .tsx, .mdx, etc.)
  content: ["./src/**/*.{js,jsx,css}"],
  rem,
  factor,
  pageWidth,
  pageHeight,
  theme: {
    fontSize: {
      xs: `${(8 * factor) / rem}rem`,
      sm: `${(9.5 * factor) / rem}rem`,
      body: `${(11.5 * factor) / rem}rem`,
      lg: `${(14 * factor) / rem}rem`,
      xl: `${(20 * factor) / rem}rem`,
    },
    fontFamily: {
      header: "opensans-regular",
      label: "opensans-regular",
      body: "opensans-light",
      highlight: "opensans-bold",
      italic: "opensans-italic",
    },
    lineHeight: {
      "1": "1",
      "1.1": "1.1",
      "1.3": "1.3",
      "1.5": "1.5",
      "1.8": "1.8",
    },
    letterSpacing: {
      none: "0",
      wide: "0.08em",
    },
    maxWidth: {
      "1/3": "33.33%",
      "1/2": "50%",
      content: `${400 * factor}px`,
      "content-max": "100%",
      contentmaxmargin: `${pageWidth - pageMargin * 2}px`,
    },
    minWidth: {
      "100": "100px",
      "125": "125px",
      "150": "150px",
      "200": "200px",
      "300": "300px",
      "1/2": "50%",
      "1/3": "33.33%",
      "1/4": "25%",
      "1/5": "20%",
      "1/6": "16.666667%",
    },
    colors: {
      white: "#ffffff",
      black: "#000000",
      blue: {
        DEFAULT: "rgb(34,44,71)",
        accent: "#0B83FF",
        disabled: "#B3D4FF",
        background: "#cde6ff",
      },
      pink: {
        200: "#fde2e4", // ← light pink
      },
      green: { 200: "rgb(204, 255, 231)" },
      gray: {
        DEFAULT: "rgb(35,45,70)",
        1: "rgb(238,238,238)",
        2: "rgb(153,153,153)",
        3: "rgb(96,96,96)",
        4: "rgb(35,45,70)",
      },
      f1: "#008FC5", // consolidated identical f-values
      f2: "rgb(56,198,61)",
      tooltip: "#333333",
      red: "rgb(234,1,0)",
    },
    extend: {
      width: {
        page: `${pageWidth}px`,
        image: `${imageWidth * factor}px`,
        "image-max": "100%",
      },
      height: {
        page: `${pageHeight - marginTop - marginBottom}px`,
      },
      screens: {
        xs: "400px", // anything < 400px (used for column collapsing to 100% width)
      },
      spacing: {
        "page-margin": `${pageMargin}px`,
        "page-margin-max": `${pageMarginMax}px`,
      },
    },
  },

  plugins: [
    plugin(({ addComponents, theme }) => {
      addComponents({
        ".rich-text-content table": {
          width: "100%",
          margin: "1rem 0",
          pageBreakInside: "avoid",
          breakInside: "avoid",
        },
        /* rounded-corner helpers …  (unchanged) */
        ".rich-text-content table > *:first-child > tr:first-child th:first-child, \
.rich-text-content table > *:first-child > tr:first-child td:first-child": {
          borderTopLeftRadius: "12px",
        },
        ".rich-text-content table > *:first-child > tr:first-child th:last-child, \
.rich-text-content table > *:first-child > tr:first-child td:last-child": {
          borderTopRightRadius: "12px",
        },
        ".rich-text-content table > *:last-child > tr:last-child th:first-child, \
.rich-text-content table > *:last-child > tr:last-child td:first-child": {
          borderBottomLeftRadius: "6px",
        },
        ".rich-text-content table > *:last-child > tr:last-child th:last-child, \
.rich-text-content table > *:last-child > tr:last-child td:last-child": {
          borderBottomRightRadius: "6px",
        },

        ".rich-text-content th": {
          backgroundColor: theme("colors.blue.accent"),
          color: "#fff",
          border: "1px solid #fff",
          padding: "0.5rem",
          fontSize: theme("fontSize.body"),
        },
        ".rich-text-content td": {
          backgroundColor: theme("colors.blue.background"),
          color: theme("colors.black"),
          border: "1px solid #fff",
          padding: ".33rem .25rem",
          fontSize: theme("fontSize.sm"),
        },
        ".rich-text-content td sub": {
          color: theme("colors.black"),
          fontSize: theme("fontSize.sm"),
        },

        // optional shrink helpers
        ".rich-text-content .table-font-shrink-1": { fontSize: "0.9rem" },
        ".rich-text-content .table-font-shrink-1 th, \
.rich-text-content .table-font-shrink-1 td": {
          fontSize: "inherit",
          padding: ".33rem .25rem",
        },
        ".rich-text-content .table-font-shrink-2": { fontSize: "0.8rem" },
        ".rich-text-content .table-font-shrink-2 th, \
.rich-text-content .table-font-shrink-2 td": {
          fontSize: "inherit",
          padding: ".33rem .25rem",
        },

        // rich text inline images
        ".rich-text-inline-images img": {
          height: "1em", // = font‑size
          width: "auto",
          verticalAlign: "text-bottom",
        },
      });
    }),
  ],
};
